// extracted by mini-css-extract-plugin
export default {"root":"PhoneCard_root__mCEkU","header":"PhoneCard_header__iou8O","phone":"PhoneCard_phone__fJTiX","button":"PhoneCard_button__9UthY"};